/* eslint-disable react/jsx-pascal-case */
/* Original name @uswitch/trustyle.call-out */
/** @jsx jsx */
import * as React from 'react'
import { jsx, Themed } from 'theme-ui'
import { Palette } from '../../utils/palette'
import { DynamicSparkIcon } from '../helpers/dynamic-spark-icon'

const CallOut = ({ title, text, icon, orientation = 'left', bold = false, className }) => {
  const flexDirection = orientation === 'left' ? 'row' : 'column'

  const mainText = (
    <React.Fragment>
      <If condition={title}>
        <Themed.h3
          sx={{
            marginTop: '-3px',
            marginBottom: 'xxs',
            variant: 'elements.call-out.heading',
          }}
        >
          {title}
        </Themed.h3>
      </If>
      <Palette
        as={Themed.p}
        sx={{
          marginY: 0,
          variant: 'elements.call-out.text',
          fontWeight: bold ? '700' : 'normal',
        }}
        px={{
          color: 'accentColorText',
        }}
      >
        {text}
      </Palette>
    </React.Fragment>
  )

  return (
    <Palette
      as='div'
      sx={{
        borderRadius: 4,
        paddingX: 'sm',
        paddingY: 'sm',
        variant: 'elements.call-out.main',
      }}
      px={{
        backgroundColor: 'accentColor',
      }}
      className={className}
    >
      <If condition={icon}>
        <div
          sx={{
            display: 'flex',
            flexDirection: flexDirection,
          }}
        >
          <div
            sx={{
              flexGrow: 0,
              flexShrink: 0,
              flexBasis: ({ space }) => space.sm,
              marginRight: 'xs',
              marginBottom: 'sm',
              variant: 'elements.call-out.icon-container',
            }}
          >
            <div
              sx={{
                borderRadius: '50%',
                padding: '20%',
                variant: 'elements.call-out.icon',
              }}
            >
              <DynamicSparkIcon color='white' glyph={icon} />
            </div>
          </div>

          <div>{mainText}</div>
        </div>
      </If>

      <If condition={!icon}>{mainText}</If>
    </Palette>
  )
}

export default CallOut
